import { Button, Card, CardActions, Link, useTheme } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React, { useState } from 'react';

import PublicPolicyModal from './public-policy-modal';
import PolicyAvatar from '../../policy-bundle-card/policy-avatar';
import PolicyCardContent from '../../policy-bundle-card/policy-card-content';
import PolicyCardHeader from '../../policy-bundle-card/policy-card-header';

import * as GQL from '~/graphql/generated/client';

interface Props {
  className?: string;
  policy: GQL.PolicyFragment;
  index?: number;
}

const PublicPolicyListImpl: React.FC<Props> = ({
  className,
  policy,
  index,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const onRemoveHandler = () => {
    setOpen(false);
  };
  return (
    <>
      <Card
        className={className}
        onClick={() => setOpen(true)}
        sx={{ cursor: 'pointer' }}
      >
        <div className="card-header-content">
          <PolicyCardHeader policy={policy} avatar={<PolicyAvatar />} />
          <PolicyCardContent policy={policy} />
        </div>
      </Card>
      <PublicPolicyModal
        {...{
          className,
          onRemoveHandler,
          open,
          setOpen,
          policy,
        }}
      />
    </>
  );
};

export const PublicPolicyCard = muiStyled(PublicPolicyListImpl)(
  ({ theme }) => css`
    &.MuiCard-root {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      max-width: 352px;
      height: 430px;
    }
    .content-wrapper {
      flex-grow: 1;
    }
  `
);

export default PublicPolicyCard;
